export const defaultMiddlewareConfiguration = {
    immutableCheck: {
        // Use longer timeout when running under vitest because we now run tests
        // concurrently with builds and can experience timeouts.
        warnAfter: ((typeof process !== "undefined") && process.env.VITEST) ? 1000 : 32
    },
    serializableCheck: {
        // Use longer timeout when running under vitest because we now run tests
        // concurrently with builds and can experience timeouts.
        warnAfter: ((typeof process !== "undefined") && process.env.VITEST) ? 1000 : 32
    }
};
